import React, { Fragment } from 'react'
import { classnames } from '../../utils/classnames'
import RequiredBadge from './RequiredBadge'

import './styles/ListDropDown.css'

const optionValue = (item) => (item.id === null || item.id === undefined ? '' : item.id)

const selectedValue = (selected) => {
	if (selected === null || selected === undefined || selected === '') return ''
	const parsed = parseInt(selected, 10)
	return Number.isNaN(parsed) ? '' : String(parsed)
}

const uniqueItems = (items) => {
	const seen = new Set()
	return items.filter((item) => {
		const key = String(optionValue(item))
		if (seen.has(key)) return false
		seen.add(key)
		return true
	})
}

export const ListDropDown = ({
	label,
	items,
	name,
	onChange,
	selected,
	description = '',
	limit = 5,
	empty = 'There are no items to display...',
	className = '',
	isRequired = false,
	readOnly = false,
	placeholder = true,
}) => {
	const choices = uniqueItems(items)
	const currentValue = selectedValue(selected)

	if ( !readOnly ) {
		if (!choices.length)
			return (
				<div className={className}>
					<label htmlFor={name}>{label} {isRequired === 1 && <RequiredBadge value={selected} />}{' '}</label>
					{empty}
				</div>
			)

		if (choices.length <= limit) {
			return (
				<Fragment>
					<label >{label} {isRequired === 1 && <RequiredBadge value={selected} />}{' '}</label>
					{description && (
						<div className="input--description">{description}</div>
					)}
					<div className="dropdownListInline">
						{choices.map((item, index) => {
							const value = optionValue(item)
							const inputId = value === '' ? `${name}-empty` : value
							const checked = currentValue === String(value)
							return (
							<div key={value === '' ? 'empty' : value}
								className={classnames('radio', checked ? 'radio-checked' : '')}
							>
								<input
									type="radio"
									name={name}
									id={inputId}
									value={value}
									checked={checked}
									onChange={onChange}
									style={{ marginRight: '10px' }}
									required={isRequired == 1 && index == 0}
								/>
								<label htmlFor={inputId} className="form-check-label">
									{item.name}
								</label>
							</div>
							)
						})}
						<div className="invalid-feedback" />
					</div>
				</Fragment>
			)
		}

		return (
			<div className={classnames('Input', className)}>
				<label htmlFor={name}>{label} {isRequired === 1 && <RequiredBadge value={selected} />}{' '}</label>
				{description && (
					<div className="input--description">{description}</div>
				)}
				<select
					onChange={onChange}
					name={name}
					value={currentValue}
					className="selectInput form-control"
					required={isRequired === 1 ? true : false}
				>
					{placeholder && !choices.some((item) => optionValue(item) === '') && (
						<option value="">&lt; choose an option &gt;</option>
					)}
					{choices.map(item => {
						const value = optionValue(item)
						return (
						<option key={value === '' ? 'empty' : value} value={value}>
							{item.name ? item.name : item.title}
						</option>
						)
					})}
				</select>
			</div>
		)
	} else {

		// print selected option in readonly mode
		return (
			<Fragment>
				<label>{label} {isRequired === 1 && <RequiredBadge value={selected} />}{' '}</label>
				{choices.map(item => {
					const value = optionValue(item)
					if ( currentValue === String(value) ) {
						return (
							<span key={value === '' ? 'empty' : value}>{item.name ? item.name : item.title}</span>
						)
					}
				})}
			</Fragment>
		)

	}
  
}

